import * as R from 'ramda'
import axios from 'axios'
import { load_one, load_many } from '@/store/action-helpers'

// noinspection JSUnusedGlobalSymbols
export default {

    loadAllByJobId: load_many('prices', { params: { job: ':jobId' } }),
    loadAllByOfferId: load_many('offers/:offerId/prices'),
    loadAllByVariantId: load_many('variants/:variantId/prices'),
    loadOne: load_one('prices/:id'),

    async loadAllByOfferModels({ dispatch }, { offerModels, params = {}, force }) {
        return R.compose(

            // Promises und Result zusammenfassen
            // > [ Promise<Price>, Promise<Price>, Promise<Price> ]
            // < Promise<Array<Price>>
            promises => Promise.all(promises).then(R.flatten),

            // Preise zu Angebot holen
            // > [ 3, 4 ]
            // < [ Promise<Price>, Promise<Price>, Promise<Price> ]
            R.chain(offerId => dispatch('loadAllByOfferId', { offerId }, params, force)),

            // Angebots-IDs einlesen
            // > [ { id: 3, ... }, { id: 4, ... } ]
            // < [ 3, 4 ]
            R.map(R.prop('id')),

        )(offerModels)
    },

    async patch({ dispatch }, { id, patch }) {
        // Speichern
        await axios.patch(`/api/v1/prices/${id}`, patch)

        // Preis laden
        return dispatch('loadOne', { id, force: true })
    },

}
